import React from 'react';
import './ToggleButton.css'


type Props = {
  checked: boolean,
  onChange: (checked: boolean) => void,
}

export const ToggleButton = (props: Props): React.ReactElement => {
  return (
    <label className="switch">
      <input type="checkbox" checked={props.checked} onChange={(e) => {
        props.onChange(e.target.checked);
      }} />
      <span className="slider round"></span>
    </label>
  )
}